import { Tooltip } from '@outdoorsyco/bonfire';
import { SVGProps } from 'react';
import { useIntl } from 'react-intl';

import ProIcon from '@/assets/pro/pro-badge.svg';

interface IProBadgeProps {
  Icon?: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  className?: string;
  width?: number;
  height?: number;
  // Render the tooltip at <body> level. Needed when the badge sits inside an
  // `overflow: hidden` container (e.g. the search-map card/carousel) that would
  // otherwise clip the tooltip or stack it below sibling controls.
  usePortal?: boolean;
  onMouseEnter?: (e: React.MouseEvent<HTMLSpanElement>) => void;
  onMouseLeave?: (e: React.MouseEvent<HTMLSpanElement>) => void;
}

export const ProBadge = ({
  Icon = ProIcon,
  className,
  width = 34,
  height = 18,
  usePortal,
  onMouseEnter,
  onMouseLeave,
}: IProBadgeProps) => {
  const intl = useIntl();
  return (
    <Tooltip
      content={intl.formatMessage({
        defaultMessage:
          'This host operates as a business, ensuring a high quality & reliable experience.',
        id: 'Ez7ik0',
      })}
      className={className}
      usePortal={usePortal}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}>
      <Icon width={width} height={height} />
    </Tooltip>
  );
};
